<template>
  <div class="login">
    <h2>{{'auth.welcome' | translate}}</h2>
  </div>
</template>

<script>
  import configs from 'services/configs'
  import Vue from 'vue'
  import ajax from 'services/ajax'

  export default {
    name: 'login',
    mounted () {
      if (typeof this.$route.query.token !== 'undefined') {
        // Query string params
        if (this.$route.query.region){
          localStorage.setItem('region', this.$route.query.region)
        }else {
          localStorage.setItem('region', 'BR')
        }

        if (this.$route.query.token){
          localStorage.setItem('token', this.$route.query.token)
        }

        // Set the locale for VeeValidate
        const availableLangs = ['br', 'en']
        if(this.$route.query.lang && availableLangs.includes(this.$route.query.lang)){
          Vue.i18n.set(this.$route.query.lang)
        } else {
          Vue.i18n.set('br')
        }

        ajax.run(this, 'customer/region', (data) => {
          // Set WHMCS base URL
          localStorage.setItem('whmcs_base_url', data.region.whmcs_base_url)
          setTimeout(function () {
            this.$router.push('dashboard')
          }.bind(this), 2000)
        }, (error) => {
          console.log(error)
        })
      } else {
        this.$router.push(`/notlogged`);
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../sass/variables';
  @import '~bootstrap/scss/mixins/breakpoints';
  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';

  .login {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
    }
    width: 21.375rem;

    .down-container {
      margin-top: 3.125rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/login/Login.vue